import { useProductLoaders, Product, useCategoryLoaders } from "../../../../products"
import { usePricesHooks } from "../../../../operations"
import { CustomerType } from "../../../state/types"
import { useSystemActions } from '../../../../system'
import { writePriceListExcel } from './priceListExcel'

export const useDownloadCustomerTypeExcel = () => {
    const { product: priceProductHooks } = usePricesHooks()
    const productLoaderInitializer = useProductLoaders()
    const categoryLoaderInitializer = useCategoryLoaders()
    const systemActions = useSystemActions()

    return async (customerType: CustomerType) => {
        const { loadAllProducts } = productLoaderInitializer()
        const { loadAllCategories } = categoryLoaderInitializer()
        const { fetchCompanyById } = systemActions(customerType.companyId)

        const [pricesList, allProducts, allCategories, company] = await Promise.all([
            priceProductHooks.pricesList(customerType.id),
            loadAllProducts(true),
            loadAllCategories(),
            fetchCompanyById(customerType.companyId)
        ])

        const excludedIds = (customerType.productYields || [])
            .filter(py => py.isExcluded)
            .map(py => py.productId)

        const archivedCategoryIds = allCategories.filter(c => c.archived).map(c => c.id)

        const rows = allProducts
            .filter((p: Product) => !p.archived && !archivedCategoryIds.includes(p.categoryId) && !excludedIds.includes(p.id) && pricesList[p.id] != null)
            .map(p => ({
                categoryName: allCategories.find(c => c.id === p.categoryId)?.name || "Sin Categoría",
                name: p.name,
                price: pricesList[p.id] || 0
            }))

        writePriceListExcel({
            headerRows: [
                [company?.name || "Empresa"],
                ["Lista de Precios", customerType.name],
                ["Fecha", new Date().toLocaleDateString()]
            ],
            rows,
            fileName: `Lista_de_Precios_${customerType.name.replace(/\s/g, '_')}.xlsx`
        })
    }
}
